
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbTipoEventoPsim extends AppService {
  abstract getAllNotificacao(filter: AppFilter): Observable<any>;
  abstract deleteNotificacao(entityId: number);
  abstract getAllTipoNotificacaoBySitemaPsim(sistemaPsim, notificacaoId): Observable<any>;
  abstract saveNotificacoes(notificacoes): Observable<any>;
  abstract getNotificacao(id): Observable<any>;
}
